import Slider from "react-slick";
import {useAuth} from "../../../services/use-auth";

const getSlickConfig = (count) => {
    return {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: Math.min(4, count),
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: Math.min(2, count),
                    arrows: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    }
};

export default function SponsorsBlock({sponsorBlockName, sponsors}) {
    const auth = useAuth();
    if (!sponsors.length || !auth.user) {
        return null;
    }

    return (
        <div className="brands-logo">
            <h5>{ sponsorBlockName }</h5>
            <Slider
                className={'brands-slick'}
                {...getSlickConfig(sponsors.length)}
            >
                { sponsors.filter((sponsor) => !!sponsor.image).map(
                    sponsor => {
                        if (sponsor.url) {
                            return <a href={ sponsor.url } target="_blank" rel="noreferrer">
                                <img src={ sponsor.image } alt=""/>
                            </a>;
                        } else {
                            return <img src={ sponsor.image } alt=""/>
                        }
                    }
                )
                }
            </Slider>
        </div>

    )
}
